'use client'
import { Button, ButtonProps, cn, forwardRef, Ripple, Spinner, useButton } from "@heroui/react"

export const LightButton = ({ className, children, ...reset }: ButtonProps) => {
  return <Button className={cn("border-theme-primary/20 border-[1px]", className)} variant="bordered" radius="full" {...reset}>{children}</Button>
}

export const DarkButton = forwardRef<'button', ButtonProps>((props, ref) => {
  const { Component,
    domRef,
    children,
    styles,
    spinnerSize,
    spinner = <Spinner color="current" size={spinnerSize} />,
    spinnerPlacement,
    startContent,
    endContent,
    isLoading,
    disableRipple,
    getButtonProps,
    getRippleProps,
    isIconOnly, } = useButton({ radius: 'full', ...props, ref })
  return <Component
    {...getButtonProps()}
    ref={domRef}
    className={cn(styles, "bg-btn-primary text-theme-white", props.className)}
  >
    {startContent}
    {isLoading && spinnerPlacement === "start" && spinner}
    {isLoading && isIconOnly ? null : children}
    {isLoading && spinnerPlacement === "end" && spinner}
    {endContent}
    {!disableRipple && <Ripple {...getRippleProps()} />}

  </Component>
})

export const ListButton = ({ children, className, ...props }: ButtonProps) => {
  return (
    <Button className={cn("h-auto border-b-[1px] border-b-theme-primary/5 block",
      "py-[16px] pl-[8px] text-left font-bold text-[14px] text-theme-primary",
      className
    )}
      variant="light" radius="none" fullWidth
      {...props}
    >
      {children}
    </Button>
  )
}